<template>
    <div id='app'>
        <div class="container">

            <Game ref="game_vue" v-if="page_index == 'Game'"></Game>
            <div v-if="page_index == 'Main'">
                <Top :chn="chn"></Top>
                <Main :chn="chn" ref="main_vue"></Main>
            </div>
        </div>

        <Dialog :visible="show_dialog" :msg="msg" @close="close()" @confirm="confirm()"></Dialog>

    </div>
</template>

<script>

import Top from "./components/Top.vue"
import Main from "./components/Main.vue"
import Game from "./components/Game.vue"
import Dialog from "./components/sub/Dialog.vue"

module.exports = {
    name: 'app',
    components: {
        Top, Main, Game, Dialog
    },
    data() {
        return {
            page_index: 'Main',
            chn: '',
            ret: {},

            show_dialog: false,
            msg: {},

        }
    },
    created() {
        // this.get_page_type()
        var self = this
        self.$eventBus.$on('start_play', (item) => {
            console.log('start_play ', item)
            if (item.open) {
                self.page_index = 'Game'
                self.$nextTick(() => {
                    console.log(self.$refs['game_vue'])
                    self.$refs['game_vue'].init(item)
                })

            }
        })
        self.$eventBus.$on('back_main', (item) => {
            console.log('back_main ', item)
            self.page_index = 'Main'
            self.init(() => { self.$refs['main_vue'].init(self.ret) })
        })

        self.$eventBus.$on('show_dialog', (item) => {
            self.msg = item
            self.show_dialog = true
            self.callback = item.callback
        })

        self.init(() => { self.$refs['main_vue'].init(self.ret) })
    },
    mounted() {
        var self = this;

        (function () {
            function fit_block() {
                var is_pc = !(navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))
                var clientw = is_pc ? 750 : document.documentElement.clientWidth
                var height = document.documentElement.clientHeight

                var w = 1080
                var ws = 1080
                var scaleX = clientw / w
                var scaleX2 = clientw / 1080
                var scaleXs = clientw / ws

                var ele = document.querySelector('#app').style

                ele.transformOrigin = '0px 0px 0px'
                ele.webkitTransformOrigin = '0px 0px 0px'
                ele.transform = 'scale(' + scaleX + ')'
                ele.webkitTransform = 'scale(' + scaleX + ')'
                ele.display = 'block'
                ele.top = (scaleX) + 'px'
                ele.height = (height / scaleX) + 'px'

            }


            function fit_block_tran() {
                var is_pc = !(navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))
                var clienth = is_pc ? 750 : document.documentElement.clientHeight
                var height = document.documentElement.clientWidth

                var w = 1080
                var ws = 1080
                var scaleX = clienth / w

                var ele = document.querySelector('#app').style

                ele.transformOrigin = '0px 0px 0px'
                ele.webkitTransformOrigin = '0px 0px 0px'
                ele.transform = 'scale(' + scaleX + ')'
                ele.webkitTransform = 'scale(' + scaleX + ')'
                ele.display = 'block'
                ele.top = (scaleX) + 'px'
                ele.height = (height / scaleX) + 'px'

            }

            function fit_w_h() {
                var w = document.documentElement.clientWidth
                var h = document.documentElement.clientHeight
                var ele = document.querySelector('body').style
                console.log(self.$game_config.is_h5)
                if (w > h && self.$game_config.is_h5) {
                    ele.transformOrigin = '0px 0px 0px'
                    ele.transform = 'rotate(-90deg)  translateX(' + -h + 'px)'

                    fit_block_tran()
                } else {

                    ele.transform = 'rotate(0deg)';
                    fit_block()
                }

            }
            fit_w_h()
            window.onresize = function () {
                fit_w_h()
            }
        })()
    },
    methods: {
        page(type) {
            return this.page_index == type
        },
        init(cb) {
            var self = this
            var args = this.$game_config.getQueryVariable(2)
            this.$httpr.post("/pic_find_holes_guide/init?r=" + Math.random(), args, (err, res) => {
                if (err) { return cb && cb() }
                self.chn = res.data.channel_id.toString()
                self.$set(self, 'ret', res.data)

                cb && cb()
            })
        },
        close() {
            this.show_dialog = false
            this.msg = {}
        },
        confirm() {
            this.show_dialog = false
            this.msg = {}

        }

    },
    computed: {
    }
}
</script>

<style scoped>
#app {
    top: 0px;
    width: 1080px;
    overflow-x: auto;
}

.container {
    height: 100%;
    overflow: auto;
}
</style>